import { Http } from '@/lib/http';

export class PrimaryAccountCategoriesService extends Http {
    constructor() {
      super();
      
      this.endpoint = 'gl/settings/primary-account-categories';
    }

    initialize() {
      return this.httpClient().get(`${this.endpoint}`);
    }
  
    create(payload) {
      return this.httpClient().post(`${this.endpoint}`, payload);
    }
  
    findAll() {
      return this.httpClient().get(`${this.endpoint}`);
    }

    findDefault() {
      return this.httpClient().get(`${this.endpoint}/default`);
    }
  
    update(id, payload) {
      return this.httpClient().put(`${this.endpoint}/${id}`, payload);
    }
  
    delete(id) {
      return this.httpClient().delete(`${this.endpoint}/${id}`);
    }
  }